import { AuthProviderProps } from "react-oidc-context";
import { useAuthStore } from "./src/store/auth/auth.store";
import { stripOidcParams } from "@/lib/oidc/oidc.util";

const oidcConfig: AuthProviderProps = {
    client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
    redirect_uri: window.location.origin,
    authority: import.meta.env.VITE_OIDC_SERVER_URL,
    client_secret: import.meta.env.VITE_OIDC_CLIENT_SECRET,
    scope: "openid profile email",
    post_logout_redirect_uri: window.location.origin,
    onSigninCallback: (user) => {
        const strippedUrl = stripOidcParams(window.location.href);
        window.history.replaceState({}, document.title, strippedUrl);

        if (user?.access_token) {
            useAuthStore.getState().setAuthToken(user.access_token);

            // Get the stored redirect URL and navigate to it
            const redirectUrl = useAuthStore.getState().redirectUrl;
            if (redirectUrl) {
                window.location.href = redirectUrl;
                useAuthStore.getState().clearRedirectUrl();
            }
        }
    },
};

export default oidcConfig;
